import React from 'react';
import './Footer.css'; // Make sure to create this CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="/privacy-policy">Privacy Policy &nbsp;</a>
        <a href="/terms-of-service">Terms Of Service</a>
      </div>
      <div className="footer-copyright">
        © 2024 - Reel Tok
      </div>
    </footer>
  );
};

export default Footer;
